import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from "@ngx-formly/core";

@Component({
  standalone: false,
  selector: "formly-button",
  templateUrl: "./button.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldButton extends FieldType {

  override defaultOptions = {
    props: {
      type: 'button',
      btnClass: 'btn-primary',
    }
  };

  onClick() {
    if (this.props.click) {
      this.props.click(this.field);
    }
  }

}
